import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SuppliersBasketFeatureComponent} from './suppliers-basket-feature/suppliers-basket-feature.component';
import {SuppliersBasketUiModule} from '@lib/basket/suppliers-basket/ui';

@NgModule({
    imports: [CommonModule, SuppliersBasketUiModule],
    declarations: [SuppliersBasketFeatureComponent],
    exports: [SuppliersBasketFeatureComponent],
})
export class SuppliersBasketFeatureModule {}
